import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'
import {i18n} from '@toolify/client/src/setup/i18n'
import {getPermissionTypeLabel} from '@toolify/client/src/modules/permissions/functions/getPermissionTypeLabel'
import {getRequestedForEntityPhrase} from '@toolify/client/src/modules/notifications/functions/getRequestedForEntityPhrase'

export class WorkspacePermissionRequestPendingNotificationStrategy extends DefaultNotificationStrategy<NotificationType.WorkspacePermissionRequestPending> implements INotificationTypeStrategy {
  getBrowserNotification(
    notification: INotificationResponseInstance<NotificationType.WorkspacePermissionRequestPending>,
    authorNick: string,
  ): IBrowserNotification {
    const p = notification.payload
    const permissionType = p.workspacePermissionRequest?.permissionType
    const requestedFor = p.workspacePermissionRequest?.requestedFor
    return {
      sound: getNotificationSoundUrl('new-notification.wav'),
      title: ENV.AppBrandingName,
      body: i18n.global.t('notifications.browser.workspacePermissionRequestPendingBody', {
        authorNick,
        requestedForPhrase: getRequestedForEntityPhrase(requestedFor?.entityType),
        requestedForName: requestedFor?.name ?? '',
        workspaceName: p.workspaceName,
        permissionType: permissionType ? getPermissionTypeLabel(permissionType).toLocaleLowerCase() : '',
      }).toString(),
    }
  }
}
